import React from "react";
import { render } from "react-dom";
import AdminPage from "./src/AdminPage";
import { getEmailContent } from "./src/utils/ajax";

/**
 * Render the WP Mail Pro admin page.
 */
if (document.querySelector("#wpmp-admin-page-container")) {
  const renderAdminPage = () => {
    render(<AdminPage />, document.querySelector("#wpmp-admin-page-container"));
  };

  document.addEventListener("DOMContentLoaded", renderAdminPage);
}

(function ($) {
  const previewIframe = document.querySelector("#email-preview-iframe");

  if (!previewIframe) {
    return;
  }

  /**
   * Load the iframe content.
   */
  const loadIframeContent = async () => {
    const result = await getEmailContent($(previewIframe).data("email-id"));

    if (result.success && result.content) {
      const $body = $(previewIframe).contents().find("body");
      $body.html(result.content);
    }
  };

  loadIframeContent();
})(jQuery);
